
































import Popup from '@/views/organisms/Popup.vue'
import BlueButton from '@/views/atoms/BlueButton.vue'
import TextBox from '@/views/atoms/TextBox.vue'
import CommentAdd from '@/views/organisms/CommentAdd.vue'
import CommentHistory from '@/views/organisms/CommentHistory.vue'
import ApiClient from '@/common/api'
import store from '@/store'
import RightBox from '@/views/molecules/RightBox.vue'
import SearchButton from '@/views/atoms/SearchButton.vue'
import CheckBox from '@/views/atoms/CheckBox.vue'
import StatusBox from '@/views/molecules/StatusBox.vue'
import Global from '@/common/global.js'

export default
  components: {
    Popup
    BlueButton
    TextBox
    CommentAdd
    CommentHistory
    RightBox
    SearchButton
    CheckBox
    StatusBox
  }

  props:
    export_id:
      type: String
      default: ''
    ship_comment:
      type: String
      default: ''
    ship_comment_id:
      type: String
      default: ''
    voy:
      type: String
      default: ''
    ship_name:
      type: String
      default: ''
    loading_area:
      type: String
      default: ''
    landing_area:
      type: String
      default: ''
    booking:
      type: String
      default: ''
    shipper_name:
      type: String
      default: ''
    statusData:
      type: Object
      default: {}

  watch: {
    list: (e) ->
      @list = e
    agentList: (e) ->
      @agentList = e
  }

  data: () ->
    list: []
    agentList: []
    mailList: store.getters.mailList,
    mailaddressList: [],
    postaddressName: [],
    address: '',
    postaddress: [],
    statusList: Global.status(),

  created: () ->
    store.dispatch('initPostParam')
    api = new ApiClient()
    data = await api.get('/fc/comment/detail/' + @export_id)
    data.detail.ship_comment = @ship_comment
    @list = data.list.in_house
    @agentList = data.list.agent
    store.dispatch('setDetailParam', data)
    for rows, index in await @mailList
      @mailaddressList.push(rows)

  methods: {
    close_popup: (e) ->
      @$emit('close_popup')
    save_ship_comment: () ->
      getParam = store.getters.getPostParam
      if @ship_comment_id
        param =
          id: Number(@ship_comment_id)
          voy: @voy
          ship_name: @ship_name
          loading_area: @loading_area
          landing_area: @landing_area
          ship_comment: getParam.ship_comment
      else
        param =
          voy: @voy
          ship_name: @ship_name
          loading_area: @loading_area
          landing_area: @landing_area
          ship_comment: getParam.ship_comment
      api = new ApiClient()
      data = await api.post('/fc/ship_comment/save', param)
      if data.errors.length == 0
        @$emit('click')
    save_comment: (agent_flg) ->
      getParam = store.getters.getPostParam
      list = @list
      comment = getParam.comment
      if agent_flg == 1
        list = @agentList
        comment = getParam.agent_comment
      if !comment
        return alert('コメントを入力してください')
      else
        if list
          if list[0].comment == comment
            return alert('入力されたコメントは保存、送信済みです')
        param = 
          id: getParam.id
          export_id: @export_id
          agent_flg: agent_flg
        if agent_flg == 0
          param.comment = getParam.comment
        else
          param.comment = getParam.agent_comment
        api = new ApiClient()
        data = await api.post('/fc/comment/save', param)
        if data.errors.length == 0
          @$emit('click')
    send_mail: (agent_flg) ->
      getParam = store.getters.getPostParam
      list = @list
      comment = getParam.comment
      if agent_flg == 1
        list = @agentList
        comment = getParam.agent_comment
      if @postaddress.length == 0 || !comment
        if !comment
          return alert('コメントを入力してください')
        return alert('メールアドレスを選択してください')
      else
        if list
          if list[0].comment == comment
            return alert('入力されたコメントは保存、送信済みです')
        @disabled = true
        if getParam.id
          param = 
              id: getParam.id
              export_id: @export_id
              mail_list: @postaddress
              agent_flg: agent_flg
        else
          param = 
              export_id: @export_id
              mail_list: @postaddress
              agent_flg: agent_flg
        param.mail_name_list = @postaddressName
        param.comment = comment
        api = new ApiClient()
        data = await api.post('/fc/comment/send_mail', param)
        if data.errors.length == 0
          @$emit('click')
    addressChange: (e) ->
      @address = e
    addressCheck: (e) ->
      if e
        mailaddress = @postaddress.map (el) -> el.mailaddress
        index = mailaddress.indexOf(@address)
        if index < 0
          @postaddress.push('mailaddress': @address)
          for lists in @mailaddressList
            for item in lists
              if item.mailaddress == @address
                @postaddressName.push(item.name)
      else
        mailaddress = @postaddress.map (el) -> el.mailaddress
        index = mailaddress.indexOf(@address)
        @postaddress.splice(index, 1)
        @postaddressName.splice(index, 1)
    statusChange:(v, i, id) ->
      @$emit('statusChange', v, i, id)
      @$emit('close_popup')
  }
